export const sofaTypes = {
  lycksele: {
    covers: [
      'black',
      'grindtorp-multicolour',
      'knisa-light-grey',
      'ransta-natural',
      'vansbro-dark-grey',
      'vansbro-yellow',
    ],
    legs: null,
  },
  ektorp: {
    covers: [
      'alhamn-dark-grey-blue',
      'alhamn-dark-yellow-brown',
      'alhamn-deep-orange-red',
      'blekinge-white',
      'hakebo-dark-grey',
      'hakebo-grey-green',
      'hemmesta-grey-green',
      'hemmesta-light-beige',
      'hillared-anthracite',
      'hillared-beige',
      'hillared-dark-blue',
      'karlshov-beige-multicolour',
      'kilanda-brown-red',
      'kilanda-dark-blue',
      'kilanda-grey-brown',
      'kilanda-light-beige',
      'mangbyn-brown-multicolour',
      'naggen-beige',
      'naggen-grey-blue',
      'naggen-grey-green',
      'tallmyra-beige',
      'tallmyra-blue',
      'tallmyra-dark-green',
      'tallmyra-light-green',
      'tallmyra-medium-grey',
      'tallmyra-white-black',
    ],
    legs: null,
  },
  soderhamn: {
    covers: [
      'alhamn-dark-grey-blue',
      'alhamn-dark-yellow-brown',
      'alhamn-deep-orange-red',
      'blekinge-white',
      'djuparp-dark-blue',
      'fridtuna-dark-grey',
      'fridtuna-dark-grey-blue',
      'fridtuna-light-beige',
      'gransel-natural',
      'gunnared-beige',
      'gunnared-medium-grey',
      'hillared-anthracite',
      'hillared-beige',
      'hillared-dark-blue',
      'johanneshov-brown-beige',
      'johanneshov-dark-green',
      'johanneshov-dark-grey',
      'johanneshov-off-white',
      'kelinge-beige',
      'kelinge-dark-blue',
      'kelinge-dark-yellow',
      'kelinge-grey-turquoise',
      'kelinge-rust',
      'knaback-anthracite',
      'tallmyra-blue',
      'tallmyra-dark-green',
      'tallmyra-light-green',
      'tallmyra-medium-grey',
      'tallmyra-white-black',
      'tonerud-grey',
      'tonerud-red',
      'viarp-beige-brown',
      'vissle-dark-green',
    ],
    legs: null,
  },
  landskrona: {
    covers: [
      'djuparp-dark-blue',
      'grann-bomstad-black',
      'grann-bomstad-dark-beige',
      'grann-bomstad-golden-brown',
      'gunnared-beige',
      'gunnared-blue',
      'gunnared-dark-grey',
      'gunnared-light-green',
    ],
    legs: ['black', 'metal', 'wood'],
  },
  friheten: {
    covers: ['bomstad-black', 'faringe-brown-orange', 'faringe-light-grey', 'skiftebo-dark-grey'],
    legs: null,
  },
  strandmon: {
    covers: ['nordvalla-dark-grey'],
    legs: null,
  },
  smedsbyn: {
    covers: [],
    legs: null,
  },
  vinliden: {
    covers: ['hakebo-beige', 'hakebo-dark-grey', 'hakebo-light-turquoise', 'hillared-anthracite'],
    legs: null,
  },
  finnala: {
    covers: [
      'grann-bomstad-black',
      'grann-bomstad-golden-brown',
      'gunnared-beige',
      'gunnared-medium-grey',
      'tallmyra-black-grey',
    ],
    legs: null,
  },
  daretorp: {
    covers: [],
    legs: null,
  },
  saleboda: {
    covers: [],
    legs: null,
  },
  morabo: {
    covers: [
      'djuparp-dark-blue',
      'grann-bomstad-black',
      'grann-bomstad-golden-brown',
      'grann-bomstad-grey-green',
      'gunnared-dark-grey',
      'gunnared-light-green',
    ],
    legs: ['metal', 'wood'],
  },
  uppland: {
    covers: [
      'blekinge-white',
      'hakebo-dark-grey',
      'hakebo-grey-green',
      'hillared-anthracite',
      'hillared-beige',
      'hillared-dark-blue',
      'karlshov-beige-multicolour',
      'karlshov-grey-beige',
      'kelinge-anthracite',
      'kelinge-beige',
      'kelinge-grey-turquoise',
      'kelinge-rust',
      'kilanda-dark-blue',
      'kilanda-light-beige',
    ],
    legs: null,
  },
  parup: {
    covers: ['kelinge-grey-turquoise', 'vissle-grey'],
    legs: null,
  },
  vimle: {
    covers: [
      'djuparp-dark-blue',
      'djuparp-dark-green',
      'djuparp-dark-green-blue',
      'djuparp-dark-grey',
      'djuparp-red-brown',
      'grann-bomstad-black',
      'grann-bomstad-golden-brown',
      'gunnared-beige',
      'gunnared-medium-grey',
      'hallarp-beige',
      'hallarp-grey',
      'hillared-anthracite',
      'hillared-beige',
      'hillared-dark-blue',
      'johanneshov-brown-beige',
      'johanneshov-dark-green',
      'johanneshov-dark-grey',
      'johanneshov-off-white',
      'kelinge-beige',
      'kelinge-dark-blue',
      'kelinge-grey-turquoise',
      'knaback-anthracite',
      'knaback-grey-green',
      'knaback-light-beige',
      'lejde-grey-black',
      'lejde-red-brown',
      'mosshed-dark-brown',
      'mosshed-grey-green',
      'mosshed-red-brown',
      'saxemara-black-blue',
      'saxemara-light-blue',
    ],
    legs: null,
  },
  fammarp: {
    covers: ['tallmyra-black-grey', 'viarp-beige-brown'],
    legs: ['metal-silver-colour', 'wood-clear'],
  },
  sorvallen: {
    covers: ['lejde-grey-black', 'tallmyra-black-white', 'tallmyra-medium-grey', 'viarp-beige-brown'],
    legs: null,
  },
  klagshamn: {
    covers: ['faringe-brown-orange', 'faringe-light-grey', 'skiftebo-dark-grey'],
    legs: null,
  },
  kivik: {
    covers: [
      'gislatorp-grey-beige',
      'grann-bomstad-black',
      'grann-bomstad-dark-brown',
      'gunnared-beige',
      'gunnared-blue',
      'gunnared-light-brown-pink',
      'gunnared-light-green',
      'gunnared-medium-grey',
      'kelinge-grey-turquoise',
      'tallmyra-beige',
      'tallmyra-blue',
      'tallmyra-dark-green',
      'tallmyra-light-green',
      'tallmyra-medium-grey',
      'tallmyra-white-black',
      'tibbleby-beige-grey',
      'tresund-anthracite',
      'tresund-light-beige',
    ],
    legs: null,
  },
  lillehem: {
    covers: ['gunnared-brown-red', 'gunnared-dark-grey', 'vissle-beige'],
    legs: ['metal', 'wood'],
  },
  viskafors: {
    covers: ['hogalid-brown', 'lejde-anthracite', 'lejde-grey-green', 'lejde-light-beige'],
    legs: ['birch', 'brown'],
  },
  jattebo: {
    covers: [
      'axvall-dark-grey-blue',
      'axvall-off-white',
      'johanneshov-brown-beige',
      'johanneshov-dark-green',
      'samsala-brown-red',
      'samsala-dark-blue',
      'samsala-dark-brown',
      'samsala-dark-yellow-green',
      'samsala-grey-beige',
      'samsala-yellow-brown',
      'tonerud-grey',
    ],
    legs: null,
  },
  eskilstuna: {
    covers: ['gunnared-blue', 'hillared-anthracite', 'hillared-beige', 'tallmyra-white-black'],
    legs: null,
  },
  hyltarp: {
    covers: [
      'gransel-grey',
      'gransel-grey-brown',
      'gransel-natural',
      'hallarp-white',
      'hemmesta-grey-green',
      'hemmesta-light-beige',
      'kilanda-pale-blue',
      'tallmyra-blue',
      'tallmyra-dark-green',
      'tallmyra-white-black',
    ],
    legs: null,
  },
  rocksjon: {
    covers: ['blekinge-white', 'kilanda-light-beige', 'klovsta-grey-white'],
    legs: null,
  },
  grillstorp: {
    covers: ['gunnared-dark-grey', 'gunnared-light-brown-pink', 'viarp-beige-brown'],
    legs: ['black', 'metal', 'oak-natural'],
  },
  ekholma: {
    covers: [
      'hakebo-beige',
      'hakebo-dark-grey',
      'hemmesta-grey-beige',
      'hemmesta-grey-green',
      'kilanda-brown-red',
      'kilanda-grey-brown',
      'kilanda-light-beige',
      'kilanda-pale-blue',
    ],
    legs: null,
  },
  glostad: {
    covers: ['knisa-dark-grey', 'knisa-medium-blue'],
    legs: null,
  },
  salstad: {
    covers: ['knisa-light-grey'],
    legs: null,
  },
  fridhult: {
    covers: ['knisa-light-grey', 'skiftebo-yellow'],
    legs: null,
  },
  klippan: {
    covers: [
      'bomstad-black',
      'dimmelsvik-dark-grey',
      'flackarp-green',
      'flackarp-medium-grey',
      'grimsmala-black',
      'langban-bright-blue',
      'langban-bright-yellow',
      'tingetorp-yellow-white',
      'vissle-green',
      'vissle-grey',
    ],
    legs: null,
  },
  grunnarp: {
    covers: ['gunnared-beige', 'gunnared-light-brown-pink', 'gunnared-medium-grey'],
    legs: null,
  },
  'stockholm-2025': {
    covers: ['alhamn-beige', 'alhamn-dark-brown', 'alhamn-dark-turquoise', 'djurmo-grey-white'],
    legs: null,
  },
  froson: {
    covers: ['beige'],
    legs: null,
  },
  rullerum: {
    covers: [
      'grann-bomstad-beige',
      'grann-bomstad-black',
      'grann-bomstad-golden-brown',
      'lekungen-black-blue',
      'lekungen-yellow-beige',
      'tornarp-dark-grey-brown',
    ],
    legs: null,
  },
  saltsjobaden: {
    covers: [
      'blekinge-white',
      'fridtuna-dark-grey-blue',
      'fridtuna-light-beige',
      'fridtuna-yellow',
      'gunnared-beige',
      'gunnared-light-green',
      'gunnared-medium-grey',
      'tonerud-grey',
      'tonerud-red-brown',
      'vittangi-light-beige-white',
    ],
    legs: ['birch', 'metal-black', 'wood-brown'],
  },
  mannarp: {
    covers: ['gunnared-beige', 'saxemara-black-blue', 'saxemara-grey-beige'],
    legs: ['metal-black', 'wood-brown'],
  },
  gammalbyn: {
    covers: ['black', 'blue', 'brown', 'grey', 'kilanda-light-beige'],
    legs: null,
  },
  uppakra: {
    covers: [
      'axvall-dark-grey-blue',
      'axvall-off-white',
      'johanneshov-brown-beige',
      'johanneshov-dark-grey',
      'samsala-brown-red',
      'samsala-dark-blue',
      'samsala-dark-brown',
      'samsala-grey-beige',
      'samsala-yellow-brown',
    ],
    legs: ['chrome-plated', 'wood'],
  },
  hemlingby: {
    covers: ['bomstad-black', 'bomstad-dark-brown', 'knisa-dark-grey'],
    legs: null,
  },
  nyhamn: {
    covers: [
      'black',
      'knisa-grey-beige',
      'naggen-beige',
      'naggen-dark-grey',
      'skartofta-black',
      'skartofta-black-light-grey',
      'skartofta-red-brown',
    ],
    legs: null,
  },
  esseboda: {
    covers: ['knaback-anthracite', 'knaback-light-beige', 'tallmyra-blue', 'tallmyra-medium-grey'],
    legs: ['birch', 'brown'],
  },
  duvholmen: {
    covers: ['grey'],
    legs: null,
  },
  stackmora: {
    covers: [],
    legs: null,
  },
  odenslunda: {
    covers: ['vissle-dark-grey'],
    legs: null,
  },
  billesholm: {
    covers: ['grey', 'light-beige'],
    legs: null,
  },
  applaryd: {
    covers: ['gunnared-black-grey', 'gunnared-light-blue', 'lejde-grey-black', 'lejde-light-grey'],
    legs: null,
  },
  linanas: {
    covers: ['vissle-beige', 'vissle-dark-grey'],
    legs: null,
  },
  alvdalen: {
    covers: ['knisa-dark-grey', 'knisa-grey-beige'],
    legs: null,
  },
  holmsund: {
    covers: ['borgunda-beige', 'borgunda-dark-grey', 'kilanda-dark-blue', 'kilanda-grey-brown'],
    legs: null,
  },
  afjall: {
    covers: ['white'],
    legs: null,
  },
  slatorp: {
    covers: ['hakebo-dark-grey', 'hakebo-yellow-brown', 'vissle-yellow-green'],
    legs: null,
  },
  saltmyran: {
    covers: ['oreryd-blue', 'oreryd-grey-beige'],
    legs: null,
  },
  gullvalla: {
    covers: ['silkeryd-dark-grey-beige', 'silkeryd-grey-green'],
    legs: null,
  },
  valnas: {
    covers: ['alhamn-dark-grey-blue', 'alhamn-dark-yellow-brown', 'knaback-light-beige'],
    legs: null,
  },
  malmkoping: {
    covers: ['tibbleby-beige-grey', 'tibbleby-grey-green', 'tibbleby-light-beige'],
    legs: null,
  },
  vretstorp: {
    covers: [
      'hakebo-dark-grey',
      'hakebo-grey-green',
      'karlshov-beige-multicolour',
      'kilanda-dark-blue',
      'kilanda-light-beige',
    ],
    legs: null,
  },
  asvang: {
    covers: ['white'],
    legs: null,
  },
  langaryd: {
    covers: ['lejde-grey-black', 'lejde-light-grey'],
    legs: ['chrome-effect'],
  },
  danhult: {
    covers: ['kelinge-grey-turquoise', 'silkeryd-brown-red', 'silkeryd-dark-grey-beige'],
    legs: null,
  },
  lindakra: {
    covers: ['vissle-dark-grey', 'vissle-light-grey-green'],
    legs: null,
  },
  venngarn: {
    covers: ['johanneshov-brown-beige', 'johanneshov-dark-green', 'johanneshov-off-white'],
    legs: null,
  },
  'ikea-ps-2026': {
    covers: ['skiftebo-light-grey-beige'],
    legs: null,
  },
  ljungbyhed: {
    covers: ['oreryd-dark-turquoise', 'oreryd-light-beige', 'vraka-vrakarr-black', 'vraka-vrakarr-light-beige'],
    legs: null,
  },
  saxvallen: {
    covers: ['axvall-beige-white', 'vraka-vrakarr-light-beige'],
    legs: null,
  },
  hunshult: {
    covers: [],
    legs: null,
  },
  barslov: {
    covers: ['tibbleby-beige-grey', 'tibbleby-light-grey-turquoise'],
    legs: null,
  },
  brissund: {
    covers: ['hakebo-dark-grey', 'hakebo-light-turquoise'],
    legs: null,
  },
  nykil: {
    covers: ['dark-grey'],
    legs: null,
  },
  lillesater: {
    covers: ['axvall-off-white', 'gunnared-bright-green-yellow'],
    legs: null,
  },
  stockholm: {
    covers: ['seglora-dark-brown', 'seglora-natural'],
    legs: null,
  },
  balkarp: {
    covers: ['knisa-black', 'vissle-grey'],
    legs: null,
  },
  gralviken: {
    covers: ['dark-grey', 'grey'],
    legs: null,
  },
  fullero: {
    covers: ['grann-bomstad-black', 'grann-white'],
    legs: ['black-metal'],
  },
  tunsta: {
    covers: ['anthracite'],
    legs: null,
  },
  sundbron: {
    covers: ['johanneshov-brown-beige', 'johanneshov-dark-grey'],
    legs: null,
  },
  skonaback: {
    covers: ['knisa-dark-grey', 'vissle-yellow-green'],
    legs: null,
  },
  hammarn: {
    covers: ['knisa-dark-grey'],
    legs: null,
  },
  tornsborg: {
    covers: ['naggen-beige'],
    legs: null,
  },
  'stockholm-2025-alt': {
    covers: ['sundhamn-beige'],
    legs: null,
  },
} as const
